export default __webpack_public_path__ + "static/rijkswaterstaat-c6d7100a84e666ef0f7d9c0d66439918.svg";